import classNames from "classnames";
import {FiArrowDown, FiArrowUp} from "react-icons/fi";

import {percentage} from "@/lib/format";
import {PropsWithClassName} from "@/lib/types/props.ts";
import {State} from "@/pages/checks/constants.ts";

import "./CheckStatus.css";

export interface CheckStatusProps extends PropsWithClassName {
  state: State;
  uptimePercentage?: number;
}

export const CheckStatus = ({className, state, uptimePercentage}: CheckStatusProps) => (
  <div
    className={classNames(
      className,
      "d-flex justify-content-evenly align-items-center status-badge align-middle gap-2",
      {
        "status-success-brand": state === State.Up,
        "status-danger-brand": state === State.Down,
        "status-secondary-brand": state === State.Paused || state === State.Pending,
      }
    )}
  >
    <span className="text-start d-flex align-items-center gap-2">
      <div className="dot"></div>
      <div className="d-flex align-items-center">
        {state === State.Up && <FiArrowUp />}
        {state === State.Down ? <FiArrowDown /> : <></>}
        {state}
      </div>
    </span>
    <span>{uptimePercentage && percentage(uptimePercentage)}</span>
  </div>
);
